import { createDocument, getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { Select, Input } from "styled";
import axios from 'apis/axios'
import { Fragment, useCallback, useState } from "react";
import { useQuery } from "react-query";
import ReactSelect from "react-select";
import { TD, TH } from "styled/table";
import exportExcel from "utils/exportExcel";
import Modal from "components/Modal";
import {Button} from 'styled'
import toast from 'react-hot-toast';
import getFormattedDate from "utils/helpers";

const contractTypeOptions = [
  { value: 'All', label: 'All' },
  { value: 'CPKM', label: 'CPKM' },
  { value: 'NON CPKM', label: 'NON CPKM' }
];

const SoldAndCasingReport = () => {
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [data, setData] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [contractType, setContractType] = useState("All");
  const [downloading, setDownloading] = useState(false);
  const [downloadingCount, setDownloadingCount] = useState(false);
  const [selectedReportType, setSelectedReportType] = useState('fleet');
  const [soldOutStatus, setSoldOutStatus] = useState("all");
  const [fleetMap, setFleetMap] = useState({});
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const getData = async () => {
    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      setData([]);
      return;
    }
    setIsLoading(true)
    try {
      const dt = await createDocument("/report/soldAndCasingReportCounts", {
        ...(selectedFleets?.includes("all")
          ? {
            fleets: getFleetOptions().filter(item => item.value !== "all" && item.value !== "clear")
              .map((item) => item.value)
              .join(","),
          }
          : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
        ...(selectedHubs?.includes("all")
          ? {
            hubs: getHubOptions().filter(item => item.value !== "all" && item.value !== "clear")
              .map((item) => item.value)
              .join(","),
          }
          : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),
        ...(contractType && contractType !== "All" && {
          contractType: contractType
        }),
        ...(dateFrom && { dateFrom }),
        ...(dateTo && { dateTo }),
        reportType: selectedReportType,
        soldOutStatus: soldOutStatus,
      })

      console.log('dt--', dt);
      setData(dt);
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Failed to fetch data');
    } finally {
      setIsLoading(false)
    }
  }

  const setFleetMapData = () => {
    if (allHubs?.data && allFleets?.data) {
      const map = {};
      allFleets.data.forEach(fleet => {
        const hubs = allHubs.data.filter(hub => hub.fleetCode === fleet.fleetCode);
        map[fleet.fleetCode] = hubs.map(hub => hub._id);
      });
      setFleetMap(map);
    }
  }

  const getDownloadCountData = async () => {
    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      return;
    }
    setDownloadingCount(true)
    try {
      const dt = await createDocument("/report/soldAndCasingReportCountsDownload", {
        ...(selectedFleets?.includes("all")
          ? {
            fleets: getFleetOptions().filter(item => item.value !== "all" && item.value !== "clear")
              .map((item) => item.value)
              .join(","),
          }
          : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
        ...(selectedHubs?.includes("all")
          ? {
            hubs: getHubOptions().filter(item => item.value !== "all" && item.value !== "clear")
              .map((item) => item.value)
              .join(","),
          }
          : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),
        ...(contractType && contractType !== "All" && {
          contractType: contractType
        }),
        ...(dateFrom && { dateFrom }),
        ...(dateTo && { dateTo }),
        reportType: selectedReportType,
        soldOutStatus: soldOutStatus,
      })

      let exportData = 
        dt?.data?.map((x, idx) => ({
          "Fleet Name": x.fleetName + " (" + x.fleetCity + ")",
          ...selectedReportType === "hub" && {"Hub Name": x.hubName},
          "Casing Count": x.casingCount ?? 0,
          "Sold Count": x.soldCount ?? 0,
          "Total Count": x.totalCount ?? 0,
        }))

      exportData.push({
        "Fleet Name": "TOTAL",
        ...selectedReportType === "hub" && {"Hub Name": ""},
        "Casing Count": dt?.totalObj?.casingCount ?? 0,
        "Sold Count": dt?.totalObj?.soldCount ?? 0,
        "Total Count": dt?.totalObj?.totalCount ?? 0,
      });
        
      exportExcel(exportData, "sold-and-casing-counts", true, selectedReportType === "hub" ? 2 : 1)

    } catch (err) {
      console.error('Error downloading count data:', err);
      toast.error('Failed to download count data');
    }
    setDownloadingCount(false)
  }

  const getDownloadData = async () => {
    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      return;
    }
    setDownloading(true)
    try {
      const myPromise = axios({
        method: 'post',
        url: "report/soldAndCasingReport/download",
        data: {
          ...(selectedFleets?.includes("all")
            ? {
              fleets: getFleetOptions()
                .filter((item) => item.value !== "all" && item.value !== "clear")
                .map((item) => item.value)
                .join(","),
            }
            : selectedFleets.length && {
              fleets: selectedFleets.join(","),
            }),
          ...(selectedHubs?.includes("all")
            ? {
              hubs: getHubOptions()
                .filter((item) => item.value !== "all" && item.value !== "clear")
                .map((item) => item.value)
                .join(","),
            }
            : selectedHubs.length && {
              hubs: selectedHubs.join(","),
            }),
          reportName: 'Casing and Sold Report',
          ...(contractType && contractType !== "All" && { contractType }),
          ...(dateFrom && { dateFrom }),
          ...(dateTo && { dateTo }),
          soldOutStatus: soldOutStatus,
        },
      });

      toast.promise(myPromise, {
        loading: 'Request Initiated, Please Hold on',
        success: (dt) => {
          return dt.data.message;
        },
        error: (err) => {
          return err?.response?.data.error ||
            err?.response?.data.message ||
            err?.message ||
            'Something went wrong'
        },
      },
        {
          success: {
            duration: 3000,
            icon: '📩',
          },
        });
    } catch (error) {
      console.error('Error downloading data:', error);
      toast.error('Failed to download data');
    } finally {
      setDownloading(false)
    }
  }

  const { data: allFleets } = useQuery(["/customer-fleet"], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery(["/customer-hub"], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
        ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }] : [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }] : [],
        ...(selectedFleets?.includes("all") ?
          allHubs?.data?.length &&
          allHubs?.data
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            }) :
          allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  return (
    <div>
      <div className="w-full px-7 flex-col justify-center items-center gap-1">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-x-3">
          <label className="w-full py-3">
            Select Fleets
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getFleetOptions()}
              value={
                selectedFleets &&
                selectedFleets?.map((fleet) => {
                  return {
                    value: fleet,
                    label: getFleetOptions()?.find((item) => item?.value === fleet)
                      ?.label,
                  };
                })
              }
              onChange={(value) => {
                let allValues = value?.map((item) => item.value);
                if (allValues?.includes("clear")) {
                  setSelectedFleets([]);
                  setSelectedHubs([]);
                  return;
                }
                if (!selectedFleets?.includes("all") && allValues.includes("all")) {
                  setSelectedFleets(["all"]);
                  return;
                }

                if (selectedFleets.includes("all")) {
                  value = value.filter(item => item.value !== "all")
                }

                let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                  value?.map((item) => item.value)?.includes(fleet._id)
                );

                let selectedHubsVal = allHubs?.data?.filter((hub) =>
                  selectedHubs?.map((item) => item)?.includes(hub._id)
                );

                setSelectedHubs(
                  selectedHubsVal
                    ?.filter((hub) =>
                      selectedFleetsVal?.find(
                        (fleet) => fleet.fleetCode === hub.fleetCode
                      )
                    )
                    .map((hub) => hub._id)
                );

                setSelectedFleets(value.map((fleet) => fleet.value));
              }}
              name="fleets"
              isMulti={true}
            />
          </label>
          <label className="w-full py-3">
            Select Hubs
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getHubOptions()}
              value={
                selectedHubs &&
                selectedHubs?.map((hub) => {
                  return {
                    value: hub,
                    label: getHubOptions()?.find((item) => item.value === hub)
                      ?.label,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);
                if (allValues.includes("clear")) {
                  setSelectedHubs([])
                  return;
                }
                if (!selectedHubs?.includes("all") && allValues.includes("all")) {
                  setSelectedHubs(["all"])
                }
                else {
                  value = value.filter(value => value.value !== "all")
                  setSelectedHubs(value.map((hub) => hub.value));
                }
              }}
              name="hubs"
              isMulti={true}
            />
          </label>

          <label className="w-full py-3">
            Contract Type
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: 'transparent',
                  minWidth: '100%',
                  '&:hover': {
                    borderColor: 'rgb(34 197 94)',
                  },
                }),
              }}
              name="contractType"
              className="shadow-md rounded-md py-1 mb-2"
              value={contractTypeOptions.find(option => option.value === contractType)}
              onChange={(option) => {
                setContractType(option.value);
              }}
              options={contractTypeOptions}
            />
          </label>

          <label className="w-full py-3">
            Report Type
            <Select
              name="reportType"
              value={selectedReportType}
              onChange={(e) => setSelectedReportType(e.target.value)}
            >
              <option value={"fleet"}>Fleet Wise</option>
              <option value={"hub"}>Hub Wise</option>
            </Select>
          </label>

          <label className="w-full py-3">
            Sold Out Status
            <Select
              name="soldOutStatus"
              value={soldOutStatus}
              onChange={(e) => setSoldOutStatus(e.target.value)}
            >
              <option value={"all"}>All</option>
              <option value={"true"}>Sold Out</option>
              <option value={"false"}>Casing Only</option>
            </Select>
          </label>
        </div>

        <div className="w-full px-7 flex mt-2 justify-start items-center gap-4">
          <label>
            Start Date{" "}
            <Input
              type="date"
              max={getFormattedDate()}
              name="dateFrom"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </label>
          <label>
            End Date{" "}
            <Input
              type="date"
              min={getFormattedDate(dateFrom)}
              max={getFormattedDate()}
              name="dateTo"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </label>
        </div>

        <div className="w-full px-7 flex mt-4 justify-end items-center gap-4">
          <Button 
            type="button" 
            disabled={(!selectedHubs.length)} 
            bgPrimary 
            onClick={() => {
              setFleetMapData();
              getData()
            }}
          >
            Search
          </Button>

          {downloadingCount ? (
            <Button type="button" disabled>
              Downloading count...
            </Button>
          ) : selectedHubs.length !== 0 && (
            <Button
              type="button"
              bgSecondary
              onClick={() => {
                getDownloadCountData()
              }}
            >
              Download Count
            </Button>
          )}

          {downloading ? (
            <Button type="button" disabled>
              Downloading...
            </Button>
          ) : selectedHubs.length !== 0 && (
            <Button
              type="button"
              bgSecondary
              onClick={() => {
                getDownloadData()
              }}
            >
              Download Data
            </Button>
          )}
        </div>

        {isLoading ? (
          <Spinner />
        ) : (
          <div className="flex flex-col m-2 lg:m-10">
            <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-200 text-center">
                    <thead className="bg-gray-50">
                      <tr>
                        <TH scope="col">S.N.</TH>
                        <TH scope="col">Fleet Name</TH>
                        {selectedReportType === 'hub' && data?.data?.[0]?.hubName ? <TH scope="col">Hub Name</TH> : null}
                        <TH scope="col">Casing Count</TH>
                        <TH scope="col">Sold Count</TH>
                        <TH scope="col">Total Count</TH>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {data &&
                        data?.data?.map((d, idx) => {
                          return <ViewList 
                            key={idx}
                            data={d} 
                            idx={idx} 
                            hubId={d.hubId} 
                            fleetId={allFleets?.data?.find(fleet=> fleet.fleetCode === d.fleetCode)?._id} 
                            fleetMap={fleetMap} 
                            contractType={contractType} 
                            reportType={selectedReportType}
                            soldOutStatus={soldOutStatus}
                            dateFrom={dateFrom}
                            dateTo={dateTo}
                          />
                        })}
                    </tbody>
                    {data?.totalObj ? <tfoot>
                      <tr className="text-gray-600 font-semibold bg-green-100">
                        <TD></TD>
                        <TD colSpan={selectedReportType === 'hub' && data?.data?.[0]?.hubName ? 2 : 1} className="text-left">
                          TOTAL
                        </TD>
                        <TD className="text-center">
                          {data?.totalObj?.casingCount}
                        </TD>
                        <TD className="text-center">
                          {data?.totalObj?.soldCount}
                        </TD>
                        <TD className="text-center">
                          {data?.totalObj?.totalCount}
                        </TD>
                      </tr>
                    </tfoot> : null}
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SoldAndCasingReport;

const ViewList = ({ data, idx, fleetId, hubId, fleetMap, contractType, reportType, soldOutStatus, dateFrom, dateTo }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [fleet, setFleet] = useState("")
  const [isLoading, setIsLoading] = useState(true)
  const [modalQueryProp, setModalQueryProp] = useState(null);

  const getModalData = async (modalQueryProp, fleetId, hubId) => {
    console.log('modalQueryProp--', modalQueryProp, fleetId, hubId, contractType);
    if ((modalQueryProp?.dateFrom && !modalQueryProp?.dateTo) || (!modalQueryProp?.dateFrom && modalQueryProp?.dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      return;
    }
    setShowModal(true)
    if (modalQueryProp) {
      setIsLoading(true);
      const dt = await createDocument("/report/soldAndCasingReport/modalInfo", {
        fleets: modalQueryProp?.fleetId,
        hubs: Array.isArray(modalQueryProp?.hubId) ? modalQueryProp.hubId.join(',') : modalQueryProp?.hubId,
        ...(contractType && contractType !== "All" && {
          contractType: modalQueryProp?.contractType
        }),
        ...(modalQueryProp?.dateFrom && { dateFrom: modalQueryProp.dateFrom }),
        ...(modalQueryProp?.dateTo && { dateTo: modalQueryProp.dateTo }),
        reportType,
        soldOutStatus: modalQueryProp?.soldOutStatus,
        status: modalQueryProp?.status,
      })
      setModalData(dt);
      setModalQueryProp(modalQueryProp);
    }
    setIsLoading(false);
  }

  const downloadDiv = (count, fleetName, hubId = "", fleetCode, status, contractType, soldOutStatus, dateFrom, dateTo) => {
    return count !== 0 ? <div className="flex gap-2 items-center justify-center text-center">
      <span
        className="hover:text-green-500 cursor-pointer"
        onClick={() => {
          getModalData({
            data: count,
            contractType,
            title: "Sold and Casing Report - " + (status === "CASING" ? "Casing" : status === "SOLD" ? "Sold Out" : "All"),
            fleetCode,
            fleetId,
            hubId,
            fleetName,
            fleetMap,
            hubId,
            status,
            soldOutStatus,
            dateFrom,
            dateTo
          });
          setFleet(fleetName)
        }}
      >
        {count ?? 0}
      </span>
    </div> : <div className="text-center">0</div>
  }

  return (
    <Fragment>
      {showModal && (
        <Modal
          handleClick={() => setShowModal(false)}
          title={modalQueryProp?.title}
          className="max-w-7xl"
        >
          {isLoading ? <Spinner /> : <>
            <h1 className="w-full flex justify-end text-end px-2 my-1">
              <Button
                onClick={() => {
                  const myPromise = axios({
                    method: 'post',
                    url: "report/soldAndCasingReport/download",
                    data: {
                      hubs: modalQueryProp.hubId
                        ? modalQueryProp.hubId.toString()
                        : (fleetMap[modalQueryProp?.fleetCode]?.length
                          ? fleetMap[modalQueryProp.fleetCode].join(",")
                          : ""),
                      ...(fleetId ? { fleets: fleetId.toString() } : {}),
                      ...(modalQueryProp.status !== "" && {
                        status: modalQueryProp.status
                      }),
                      ...(contractType && contractType !== "All" && {
                        contractType: contractType
                      }),
                      ...(modalQueryProp?.dateFrom && { dateFrom: modalQueryProp.dateFrom }),
                      ...(modalQueryProp?.dateTo && { dateTo: modalQueryProp.dateTo }),
                      soldOutStatus: modalQueryProp.soldOutStatus,
                      reportName: "Casing and Sold Report"
                    },
                  });

                  toast.promise(myPromise, {
                    loading: 'Request Initiated, Please Hold on',
                    success: (dt) => {
                      return dt.data.message;
                    },
                    error: (err) => {
                      return err?.response?.data.error ||
                        err?.response?.data.message ||
                        err?.message ||
                        'Something went wrong'
                    },
                  },
                    {
                      success: {
                        duration: 3000,
                        icon: '📩',
                      },
                    });
                }}
                className="text-blue-500 hover:scale-105 cursor-pointer text-right"
              >
                Download
              </Button>
            </h1>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <TH scope="col">S.N.</TH>
                    <TH scope="col">Stencil No.</TH>
                    <TH scope="col">Tyre Company</TH>
                    <TH scope="col">Brand</TH>
                    <TH scope="col">Tyre Size</TH>
                    <TH scope="col">Fleet Name</TH>
                    {reportType === 'hub' ? <TH scope="col">Hub Name</TH> : null}
                    <TH scope="col">Reg No.</TH>
                    <TH scope="col">Position</TH>
                    <TH scope="col">Fitment Km</TH>
                    <TH scope="col">ITM</TH>
                    <TH scope="col">RTD1</TH>
                    <TH scope="col">RTD2</TH>
                    <TH scope="col">RTD3</TH>
                    <TH scope="col">KM Covered</TH>
                    <TH scope="col">Projection KM</TH>
                    <TH scope="col">Contract Type</TH>
                    <TH scope="col">Tyre Type</TH>
                    <TH scope="col">Tyre Location</TH>
                    <TH scope="col">IP Condition</TH>
                    <TH scope="col">IP Psi</TH>
                    <TH scope="col">Original NSD</TH>
                    <TH scope="col">Material Number</TH>
                    <TH scope="col">Sold Out</TH>
                    <TH scope="col">G1NSD</TH>
                    <TH scope="col">G2NSD</TH>
                    <TH scope="col">G3NSD</TH>
                    <TH scope="col">Casing Type</TH>
                    <TH scope="col">Scrap Reason</TH>
                    <TH scope="col">Fitment Date</TH>
                    <TH scope="col">Last Insp. Date</TH>
                    <TH scope="col">Insp. By</TH>
                    <TH scope="col">Avg NSD</TH>
                    <TH scope="col">Standard Deviation</TH>
                    <TH scope="col">Sold Date</TH>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {modalData &&
                    modalData?.data?.length > 0 &&
                    modalData?.data?.map((tyre, index) => {
                      return <tr key={index}>
                        <TD>{index + 1}</TD>
                        <TD className="text-left">{tyre.stencilNo}</TD>
                        <TD className="text-left">{tyre["Tyre Company"] || "---"}</TD>
                        <TD className="text-left">{tyre.brand || "---"}</TD>
                        <TD>{tyre["Tyre Size"] || "---"}</TD>
                        <TD className="text-left">{tyre["Fleet Name"] || "---"}</TD>
                        {reportType === 'hub' ? <TD className="text-left">{tyre["Hub Name"] || "---"}</TD> : null}
                        <TD>{tyre["Reg No"] || "---"}</TD>
                        <TD>{tyre["Position"] || "---"}</TD>
                        <TD>{tyre["Fitment Km"] || 0}</TD>
                        <TD>{tyre.ITM || 0}</TD>
                        <TD>{tyre.RTD1 || 0}</TD>
                        <TD>{tyre.RTD2 || 0}</TD>
                        <TD>{tyre.RTD3 || 0}</TD>
                        <TD>{tyre["KM Covered"] || 0}</TD>
                        <TD>{tyre["Projection KM"] || 0}</TD>
                        <TD>{tyre["contractType"] || "---"}</TD>
                        <TD>{tyre["Tyre Type"] || "---"}</TD>
                        <TD>{tyre["Tyre Location"] || "---"}</TD>
                        <TD>{tyre["IP Condition"] || "---"}</TD>
                        <TD>{tyre["IP Psi"] || ""}</TD>
                        <TD>{tyre["Original NSD"] ? parseFloat(tyre["Original NSD"]).toFixed(2) : "---"}</TD>
                        <TD>{tyre["Material Number"] || "---"}</TD>
                        <TD>{tyre["Sold Out"] || "NO"}</TD>
                        <TD>{tyre.G1NSD ? parseFloat(tyre.G1NSD).toFixed(2) : "---"}</TD>
                        <TD>{tyre.G2NSD ? parseFloat(tyre.G2NSD).toFixed(2) : "---"}</TD>
                        <TD>{tyre.G3NSD ? parseFloat(tyre.G3NSD).toFixed(2) : "---"}</TD>
                        <TD>{tyre["Casing Type"] || "---"}</TD>
                        <TD>{tyre["Scrap Reason"] || "---"}</TD>
                        <TD>{tyre["Fitment Date"] || "---"}</TD>
                        <TD>{tyre["Last Insp"]?.[" Date"] || "---"}</TD>
                        <TD>{tyre["Insp"]?.[" By"] || "---"}</TD>
                        <TD>{tyre["Avg NSD"] ? parseFloat(tyre["Avg NSD"]).toFixed(2) : "---"}</TD>
                        <TD>{tyre["Standard Deviation"] ? parseFloat(tyre["Standard Deviation"]).toFixed(2) : "---"}</TD>
                        <TD>{tyre["Sold Date"] || "---"}</TD>
                      </tr>
                    })}
                </tbody>
              </table>
            </div>
          </>}
        </Modal>
      )}
      <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{idx + 1}</TD>
        <TD className="text-left">{data?.fleetName} ({data?.fleetCity})</TD>
        {reportType === 'hub' && data?.hubName ? <TD className="text-left">{data?.hubName}</TD> : null}
                        <TD>
                          {downloadDiv(data.casingCount, data.fleetName, data.hubId, data.fleetCode, "CASING", contractType, soldOutStatus, dateFrom, dateTo)}
                        </TD>
                        <TD>
                          {downloadDiv(data.soldCount, data.fleetName, data.hubId, data.fleetCode, "SOLD", contractType, soldOutStatus, dateFrom, dateTo)}
                        </TD>
                        <TD>
                          {downloadDiv(data.totalCount, data.fleetName, data.hubId, data.fleetCode, "", contractType, soldOutStatus, dateFrom, dateTo)}
                        </TD>
      </tr>
    </Fragment>
  );
}
